import { render, staticRenderFns } from "./Productos_premium.vue?vue&type=template&id=3e2ab247&"
import script from "./Productos_premium.vue?vue&type=script&lang=js&"
export * from "./Productos_premium.vue?vue&type=script&lang=js&"
import style0 from "./Productos_premium.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports